export default __webpack_public_path__ + "static/media/logo.67f494e0.png";